import React, { useState, useEffect, useContext } from 'react';
import './Cartorders.css';
import bin from '../../assets/frontend_assets/bin_icon.png';
import { useUser } from '../../Context/UserContext';
import { useNav } from '../../Context/NavContext';
import { UrlContext } from '../../Context/UrlContext';


function Cartorders({ setCategory }) {

       const { apiBaseUrl } = useContext(UrlContext);

       const API_BASE_URL = apiBaseUrl;


  const [quantities, setQuantities] = useState({});
  const [cartItems, setCartItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [orderMessage, setOrderMessage] = useState({ type: '', text: '' });
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    address: '',
    city: '',
    state: '',
    postal_code: '',
    country: '',
    phone_number: ''
  });

  const { user } = useUser();
  const { setActiveItem } = useNav();

  useEffect(() => {
    if (user?.id) {
      fetchCartOrders();
    }
  }, [user?.id]);

  const fetchCartOrders = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_BASE_URL}/cart/orders/${user.id}`);
      if (!response.ok) throw new Error('Failed to fetch cart orders');
      const data = await response.json();
      setCartItems(data);
      const initialQuantities = {};
      data.forEach(item => {
        initialQuantities[item.id] = item.count;
      });
      setQuantities(initialQuantities);
      setError(null);
    } catch (err) {
      console.error('Error fetching cart orders:', err);
      setError('Failed to load cart items');
    } finally {
      setLoading(false);
    }
  };

   const handleQuantityChange = async (id, value) => {
    const newValue = value < 1 ? 1 : value;
    setQuantities(prev => ({
      ...prev,
      [id]: newValue
    }));

    try {
      const response = await fetch(`${API_BASE_URL}/cart/orders/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ count: newValue })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to update quantity');
      }

      fetchCartOrders(); // Refresh cart data
    } catch (err) {
      console.error('Error updating quantity:', err);
      setError(err.message);
    }
  };

  const handleDelete = async (id) => {
    try {
      const response = await fetch(`${API_BASE_URL}/cart/orders/${id}`, {
        method: 'DELETE'
      });
      if (!response.ok) throw new Error('Failed to delete item');
      setQuantities(prev => {
        const updated = { ...prev };
        delete updated[id];
        return updated;
      });
      setCartItems(prev => prev.filter(item => item.id !== id));
    } catch (err) {
      console.error('Error deleting item:', err);
      setError('Failed to delete item');
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setOrderMessage({ type: '', text: '' }); // Clear message on input
  };

const handlePlaceOrder = async (e) => {
  e.preventDefault();

  const requiredFields = ['first_name', 'last_name', 'email', 'address', 'city', 'postal_code', 'country', 'phone_number'];
  const missingFields = requiredFields.filter(field => !formData[field]);

  if (missingFields.length > 0) {
    setOrderMessage({
      type: 'error',
      text: `Please fill in all required fields: ${missingFields.join(', ')}`
    });
    return;
  }

  if (!user || !user.id) {
    setOrderMessage({ type: 'error', text: 'User not logged in' });
    return;
  }

  if (cartItems.length === 0) {
    setOrderMessage({ type: 'error', text: 'Your cart is empty' });
    return;
  }

  try {
    const sub_total = calculateSubtotal();
    const shipping_fee = calculateShippingFee();
    const total = calculateTotal();
    const fullAddress = `${formData.address}, ${formData.city}, ${formData.state}`;

    const response = await fetch(`${API_BASE_URL}/orders/place`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        user_id: user.id,
        ...formData,
        address: fullAddress,
        sub_total,
        shipping_fee,
        total
      })
    });

    const data = await response.json();

    if (response.ok) {
      setOrderMessage({ type: 'success', text: 'Order placed successfully!' });

      setFormData({
        first_name: '',
        last_name: '',
        email: '',
        address: '',
        city: '',
        state: '',
        postal_code: '',
        country: '',
        phone_number: ''
      });

      setCartItems([]);
      setQuantities({});

      setTimeout(() => {
        setActiveItem('COLLECTION');
        setCategory('orders');
        setOrderMessage(null); // clear message
      }, 2000);
    } else {
      throw new Error(data.error || 'Failed to place order');
    }
  } catch (err) {
    console.error('Error placing order:', err);
    setOrderMessage({ type: 'error', text: err.message });
  }
};


  const calculateSubtotal = () => {
    return cartItems.reduce((total, item) => total + (item.unit_price * quantities[item.id]), 0);
  };

  const calculateShippingFee = () => {
    if (cartItems.length === 0) return 0;
    const totalDeliveryPrice = cartItems.reduce((total, item) => total + (item.delivery_price * quantities[item.id]), 0);
    const totalProductCount = cartItems.reduce((total, item) => total + quantities[item.id], 0);
    return totalProductCount === 0 ? 0 : Number((totalDeliveryPrice / totalProductCount).toFixed(2));
  };

  const calculateTotal = () => {
    return calculateSubtotal() + calculateShippingFee();
  };

  if (loading) return <div className="loading">Loading cart items...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="cartorders_container">
      <div className="c_orders">
        {cartItems.map((item) => (
          <div className="c_order" key={item.id}>
            <div className="c_profile">
              <div className="p_img">
                <img
                  src={`data:image/jpeg;base64,${item.product_image}`}
                  alt={item.product_name}
                />
              </div>
              <div className="p_d">
                <h3>{item.product_name}</h3>
                <div className="p_add">
                  <p>Rs. {item.unit_price}</p>
                  <p>{item.size}</p>
                </div>
              </div>
            </div>
            <div className="c_count">
              <input
                type="number"
                value={quantities[item.id]}
                onChange={(e) => handleQuantityChange(item.id, parseInt(e.target.value, 10))}
                min="1"
              />
            </div>
            <div className="c_delete">
              <img
                src={bin}
                alt="delete"
                onClick={() => handleDelete(item.id)}
                style={{ cursor: 'pointer' }}
              />
            </div>
          </div>
        ))}
      </div>

      <div className="c_details">
        <form onSubmit={handlePlaceOrder}>
          <div className="customer_details">
            <div className="block_title">
              <h2>Delivery Information</h2>
            </div>
            <div className="c_block">
              <input type="text" name="first_name" value={formData.first_name} onChange={handleInputChange} placeholder='First Name' />
              <input type="text" name="last_name" value={formData.last_name} onChange={handleInputChange} placeholder='Last Name' />
            </div>
            <div className="c_block">
              <input type="email" name="email" value={formData.email} onChange={handleInputChange} placeholder='Email Address' />
            </div>
            <div className="c_block">
              <input type="text" name="address" value={formData.address} onChange={handleInputChange} placeholder='Street' />
            </div>
            <div className="c_block">
              <input type="text" name="city" value={formData.city} onChange={handleInputChange} placeholder='City' />
              <input type="text" name="state" value={formData.state} onChange={handleInputChange} placeholder='State' />
            </div>
            <div className="c_block">
              <input type="text" name="postal_code" value={formData.postal_code} onChange={handleInputChange} placeholder='Zip-Code' />
              <input type="text" name="country" value={formData.country} onChange={handleInputChange} placeholder='Country' />
            </div>
            <div className="c_block">
              <input type="tel" name="phone_number" value={formData.phone_number} onChange={handleInputChange} placeholder='Phone' />
            </div>
          </div>

          <div className="payment_details">
            <div className="block_title">
              <h2>Cart Totals</h2>
            </div>
            <div className="c_block"><p>Sub Total</p><p>Rs. {calculateSubtotal()}</p></div>
            <div className="c_block"><p>Shipping Fee</p><p>Rs. {calculateShippingFee()}</p></div>
            <div className="c_block"><p>Total</p><p>Rs. {calculateTotal()}</p></div>
            {orderMessage.text && <div className={`message ${orderMessage.type}`}>{orderMessage.text}</div>}
            <div className="p_method">
              <h4>Payment Method</h4>
              <p>Cash on Delivery</p>
            </div>
            <div className="place_order">
              <button type="submit" disabled={cartItems.length === 0}>Place Order</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Cartorders;
